module.exports = __webpack_public_path__ + "static/media/baseline.d26a56fc.png";